import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const MODEL_PATH = "/reporte";

const buildQueryParams = (idsede = null, idperiodo = null) => {
  const params = new URLSearchParams();

  if (idsede !== null && idsede !== undefined) {
    params.append("idsede", idsede);
  }

  if (idperiodo !== null && idperiodo !== undefined) {
    params.append("idperiodo", idperiodo);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};

export const getDashboard = async (idsede = null, idperiodo = null) => {
  const params = buildQueryParams(idsede, idperiodo);
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/dashboard-v2${params}`);
  return handleResponse(response);
};

export const getTotales = async (idsede = null, idperiodo = null) => {
  const params = buildQueryParams(idsede, idperiodo);
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/totales-v2${params}`);
  return handleResponse(response);
};

export const getTendencia = async (idsede = null, idperiodo = null) => {
  const params = buildQueryParams(idsede, idperiodo);
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/tendencia${params}`);
  return handleResponse(response);
};

// Obtiene el excel file
export const downloadAsistencias = async (idsede = null, idperiodo = null) => {
  const params = buildQueryParams(idsede, idperiodo);
  const response = await HTTP_REQUEST.getFile(`${MODEL_PATH}/asistencia${params}`);
  return response; // return a blob
};

// Obtiene el excel file
export const downloadConsolidado = async (idsede = null, idperiodo = null) => {
  const params = buildQueryParams(idsede, idperiodo);
  const response = await HTTP_REQUEST.getFile(`${MODEL_PATH}/asistencia-consolidado${params}`);
  return response; // return a blob
};

// Obtiene el excel file
export const downloadFaltaron = async (idsede = null, idperiodo = null) => {
  const params = buildQueryParams(idsede, idperiodo);
  const response = await HTTP_REQUEST.getFile(`${MODEL_PATH}/asistencia-faltaron${params}`);
  return response; // return a blob
};

export const downloadParticipantes = async (idsede = null) => {
  const params = idsede ? `?idsede=${idsede}` : '';
  const response = await HTTP_REQUEST.getFile(`${MODEL_PATH}/asistencia-participante${params}`);
  return response; // return a blob
};
